// 上传门诊病历相关逻辑
import { ref } from 'vue'
export default function useMedicalRecordPop() {
  const uploadRecordVisible = ref(false)
  // 上传门诊病历取消回调
  const onClose = () => {
    uploadRecordVisible.value = false
  }
  // 补充诊疗记录
  const handleCreateOfflineCase = () => {
    uploadRecordVisible.value = true
  }
  return {
    onClose,
    uploadRecordVisible,
    handleCreateOfflineCase
  }
}
